import request from '@/utils/request'

export function selectMaterialType(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/miniUpload/selectMaterialType`,
        method: 'post',
        data,
    })
}

export function miniSelectInfo(currentPage,pageSize,data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/miniUpload/miniSelectInfo?size=${pageSize}&current=${currentPage}`,
        method: 'post',
        data,
    })
}

export function miniBatchDelete(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/miniUpload/miniBatchDelete?`,
        method: 'post',
        data,
    })
}

export function updateComposition(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/miniUpload/updateComposition?`,
        method: 'post',
        data,
    })
}

export function updateMaterialType(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/miniUpload/updateMaterialType?`,
        method: 'post',
        data,
    })
}

export function updateUnComposition(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/miniUpload/updateUnComposition?`,
        method: 'post',
        data,
    })
}

export function unDownLoad(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/miniUpload/unDownLoad?`,
        method: 'post',
        data,
    })
}


export function webSelectFloorAndPanel(data) {
    // return request.get('http:9800//serviceCenter/test')
    return request({
        url: `api/serviceCenter/floor/webSelectFloorAndPanel?access=${data}`,
        method: 'post',
    })
}
